export const environment = {
  name: 'DEV Environment',
  version: '3.0.2d',
  production: true,

  uwp: false,
  installationUrl: 'https://dev-mcomplus-gw.westeurope.cloudapp.azure.com/desktop/MComPlus.UWP.appinstaller',
  helpUrl: 'https://help-mcom.tuvsud.com/moum',
  serverUrl: 'https://dev-mcomplus-gw.westeurope.cloudapp.azure.com/api',
  umServerUrl: 'https://dev-mcomplus-gw.westeurope.cloudapp.azure.com/api',

  authOptions: {
    selfcareUrl: 'https://dev-mcomplus-gw.westeurope.cloudapp.azure.com/connect/profileedit'
  },

  oidcConfig: {
    authority: 'https://dev-mcomplus-gw.westeurope.cloudapp.azure.com',
    clientId: 'mcomplus-dev',
    scope: 'openid mcomplus.api mcomplus.security_api offline_access',
    redirectUrl: 'https://dev-mcomplus.azurewebsites.net/auth/callback',
    silentRenewUrl: 'https://dev-mcomplus.azurewebsites.net/silent/callback',
    postLogoutRedirectUri: 'https://dev-mcomplus.azurewebsites.net',
    reloginCallbackUrl: 'https://dev-mcomplus.azurewebsites.net/relogin/callback',
    wellKnownEndpoints: {
      issuer: 'https://dev-mcomplus-security.azurewebsites.net',
      authorizationEndpoint: 'https://dev-mcomplus-gw.westeurope.cloudapp.azure.com/connect/authorize',
      endSessionEndpoint: 'https://dev-mcomplus-gw.westeurope.cloudapp.azure.com/connect/endsession',
      jwksUri: 'https://dev-mcomplus-gw.westeurope.cloudapp.azure.com/connect/.well-known/jwks',
      tokenEndpoint: 'https://dev-mcomplus-gw.westeurope.cloudapp.azure.com/connect/token',
    },
    // The gateway serves the discovery document, but the user management issues tokens under its own host.
    strictIssuerValidationOnWellKnownRetrievalOff: true
  },

  appInsightsConfig: {
    instrumentationKey: '7f629cc4-0447-4e38-a06a-4137b436f831',
    enableCorsCorrelation: true
  },

  featureFlags: {
    identicalMachines: true,
    measurements: true,
    spe: true
  },
  logLevel: 0, //ALL = 0, TRACE = 1, DEBUG = 2, INFO = 3, WARN = 4, ERROR = 5, FATAL = 6, OFF = 7
};
